import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { intersection, difference } from 'lodash'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { ScrollableUserList, Loading } from 'components/UI'
import Api from 'services/Api'
import { Alert, Card } from 'ui'

import { t } from 'translations'

const ScheduleCapacityDetailModal = ({ primaryCapacity, totalCapacity, date }) => {
  const dispatch = useDispatch()
  const [scheduledUsers, setScheduledUsers] = useState()
  const [errorLoading, setErrorLoading] = useState(false)

  useEffect(() => {
    const fetchScheduledUsers = async () => {
      const { result, success } = await Api.post('users/scheduled', { users: totalCapacity, rangeStart: date, rangeEnd: date })
      if (!success) return setErrorLoading(true)
      setScheduledUsers(result.map(({ _id }) => _id))
    }

    fetchScheduledUsers()
  }, [date, totalCapacity])

  if (!scheduledUsers && !errorLoading) return <Loading />
  if (errorLoading)
    return (
      <BaseModal hideButtons title="manager.scheduleCapacity.DETAIL_MODAL" shouldCloseOnOverlayClick={false}>
        <Alert variant="danger">{t('manager.scheduleCapacity.DETAIL_MODAL.ERROR_LOADING')}</Alert>
        <div className="mt-3">
          <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
        </div>
      </BaseModal>
    )

  const primaryScheduled = intersection(primaryCapacity, scheduledUsers)
  const primaryUnscheduled = difference(primaryCapacity, primaryScheduled)
  const totalScheduled = difference(intersection(totalCapacity, scheduledUsers), primaryCapacity)
  const totalUnscheduled = difference(totalCapacity, totalScheduled, primaryCapacity)

  return (
    <BaseModal hideButtons title="manager.scheduleCapacity.DETAIL_MODAL" shouldCloseOnOverlayClick={false}>
      <h6>{t('manager.scheduleCapacity.DETAIL_MODAL.PRIMARY_SCHEDULED', { count: primaryScheduled.length })}</h6>
      <Card>
        <ScrollableUserList containerClass="bg-light mb-3" usersIds={primaryScheduled} />
      </Card>
      <h6>{t('manager.scheduleCapacity.DETAIL_MODAL.PRIMARY_UNSCHEDULED', { count: primaryUnscheduled.length })}</h6>
      <Card>
        <ScrollableUserList containerClass="bg-light mb-3" usersIds={primaryUnscheduled} />
      </Card>
      <h6>{t('manager.scheduleCapacity.DETAIL_MODAL.TOTAL_SCHEDULED', { count: totalScheduled.length })}</h6>
      <Card>
        <ScrollableUserList containerClass="bg-light mb-3" usersIds={totalScheduled} />
      </Card>
      <h6>{t('manager.scheduleCapacity.DETAIL_MODAL.TOTAL_UNSCHEDULED', { count: totalUnscheduled.length })}</h6>
      <Card>
        <ScrollableUserList containerClass="bg-light mb-3" usersIds={totalUnscheduled} />
      </Card>

      <div className="mt-3">
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default ScheduleCapacityDetailModal
